import { render } from "./CustomerInvoiceTable.vue?vue&type=template&id=fc74bfce&scoped=true"
import script from "./CustomerInvoiceTable.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceTable.vue?vue&type=script&lang=js"

import "./CustomerInvoiceTable.vue?vue&type=style&index=0&id=fc74bfce&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc74bfce"]])

export default __exports__